export default function Support() {
  return (
    <div className="page">
      <h1>Help & Support</h1>

      <p>If you need help, contact us:</p>

      <ul>
        <li>Email: info@pncnigeria.org</li>
        <li>Whatsapp: +2347089637195</li>
        <li>Response time: 24–48 hours</li>
      </ul>

      <h3>Common Issues</h3>
      <ul>
        <li>Payment not reflecting</li>
        <li>Unable to login</li>
        <li>Member data issues</li>
      </ul>
    </div>
  );
}
